export const ADMINISTRATION_AVAILABLE = "administrationAvailable";